<template>
  <Modal
    v-model="shows"
    :title="$t('add.index.213388-0')"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    :ok-text="$t('add.index.213388-1')"
    width="860"
    height="600"
    :loading="loading"
    @on-ok="submit"
    @on-cancel="shows = false"
  >
    <Form ref="details" label-position="right" :label-width="80">
      <Row span="24">
        <Col span="10">
          <FormItem :label="$t('add.index.213388-2')" prop="city">
            <Select :placeholder="$t('add.index.213388-3')" v-model="RoomCode" filterable>
              <Option
                v-for="item in userList"
                :key="item.Id"
                :value="item.RoomCode"
                >{{ item.RoomName }}({{ item.OwnerPhone }})</Option
              >
            </Select>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <device-model ref="device"></device-model>
  </Modal>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";
import DeviceModel from '../device/device.vue'

const URL = {
  GetRoshRoomList: "api/User/GetRoshRoomList", // 获取用户
  GetRoshRoomOne: 'api/User/GetRoshRoomOne', // 获取房间
  UpdateDevice3Code: 'api/CommElecDevice/UpdateDevice3Code', // 绑定设备
};

export default {
  components: {
    DeviceModel
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      query: {},
      RoomCode: '',
      userList: [],
      dataList: []
    };
  },
  watch: {
    show(value) {
      if (value) {
        this.query = {}
        this.RoomCode = ''
        switch (this.data.grade) {
          case 1:
            this.query = {
              Ccode: this.data.Ccode
            }
            break;
          case 2:
            this.query = {
              Vcode: this.data.Vcode
            }
            break;
          case 3:
            this.query = {
              Scode: this.data.Scode
            }
            break;
          case 4:
            this.query = {
              Zcode: this.data.Zcode
            }
            break;
          case 5:
            this.query = {
              Zcode: this.data.Zcode
            }
            this.RoomCode = this.data.RoomCode
            break;
          default:
            break;
        }
        this.GetRoshRoomList();
      }
    },
  },
  mounted() {},
  computed: {
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  methods: {
    addDevice() {
      this.$emit('add-device')
    },
    setDevice(list) {
      this.dataList = list
    },
    GetRoshRoomList() {
      api({
        //这里是你自己的请求方式、url和data参数
        method: "post",
        url: `${URL.GetRoshRoomList}`,
        data: { ...this.query },
        //假设后台需要的是表单数据这里你就可以更改
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      }).then((res) => {
        if (res.Success) {
          this.userList = res.Data || []
        }
      });
    },
    
    async submit() {
      const { GroupCode, DepartmentCode, CompanyCode } = JSON.parse(
        Cookies.get("AdminData")
      );

      this.dataList = (this.$refs.device.submit() || [])

      const userItem = this.userList.find(item => item.RoomCode === this.RoomCode)
      if (!userItem) {
        this.$Message["error"]({
          background: true,
          content: this.$t('add.index.213388-4'),
        });
        return
      }

      if ((this.dataList || []).length <= 0) {
					this.$Message['error']({
						background: true,
						content: this.$t('add.index.213388-5')
					});
					return;
			}

      const res = await api({
        method: "get",
        url: `${URL.GetRoshRoomOne}/${userItem.Id}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          Authorization: Cookies.get("Token"),
        },
      })

      if (res.Success) {
        const { RoomCode, Ccode, Vcode, Zcode, Scode } = res.Data
        const data = {
					IdList: (this.dataList || []).map(item => item.Id),
					GroupCode,
					CompanyCode,
					DepartmentCode,
					Unit: Scode,
					RoomNo: RoomCode,
					Block: Ccode,
					Floor: Vcode,
          Zcode,
          deviceType: 'qg'
				}
        
        api({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: URL.UpdateDevice3Code,
					data: data,
					//假设后台需要的是表单数据这里你就可以更改
					headers: {
						"Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
						"Authorization": Cookies.get('Token')
					}
				}, 'yhj').then((res) => {
					if (res.Success) {
						this.$Message['success']({
							background: true,
							content: res.Message
						});
            this.$emit('on-add')
					} else {
						this.$Message['error']({
							background: true,
							content: res.Message
						});
					}
				});

      } else {
        this.$Message["error"]({
          background: true,
          content: res.Message
        });
      }

    },
    
    
  },
};
</script>




// WEBPACK FOOTER //
// src/components/useGas/views/device/mods/add/index.vue